module.exports = __webpack_public_path__ + "img/stockantsLogo.9e12be4d.png";